import { render, staticRenderFns } from "./BasketItemSummary.vue?vue&type=template&id=2b61d7ba&scoped=true"
import script from "./BasketItemSummary.vue?vue&type=script&lang=js"
export * from "./BasketItemSummary.vue?vue&type=script&lang=js"
import style0 from "./BasketItemSummary.vue?vue&type=style&index=0&id=2b61d7ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b61d7ba",
  null
  
)

export default component.exports